var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"default",fn:function({ open }){return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"title",attrs:{"cols":"12"}},[_vm._v(" V. Wynagrodzenie ")])],1)]}}])}),_c('v-expansion-panel-content',[_c('Salary')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }